module.exports = __webpack_public_path__ + "3a54fa15282fffd86069a73a80d27c4b.svg";